export default "__VITE_ASSET__DsrfMrv___"